import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Input, Tree, Menu, Modal, Form, Dropdown } from "antd";
import kpiService from "@services/kpi.service";
import toast from "react-hot-toast";
const { Search } = Input;

const { confirm } = Modal;
// const dataList = [];

const menu = ({ node, callback }) => (
  <Menu>
    <RenameTree id={node.id} node={node} callback={callback} />
    <CreateTree parent={node.id} callback={callback} />
    {(!node.children || node.children.length === 0) && (
      <>
        <DeleteTree node={node} callback={callback} />
      </>
    )}
  </Menu>
);

function Treeview({
  name,
  checkable = false,
  customizable = false,
  loading = false,
  dataSource,
  loadData = null,
  multiple = true,
  filter: search,
  handleChange,
  handleSelect,
  handleSearch,
  handleFilterData = () => {},
  forceUpdateDataset = false,
}) {
  const [filter, setFilter] = useState("");
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [dataList, setDataList] = useState([]);

  const onDrop = async (info) => {
    // const dropKey = info.node.key;
    // const dragKey = info.dragNode.key;
    // const dropPos = info.node.pos.split("-");
    // const dropPosition =
    //   info.dropPosition - Number(dropPos[dropPos.length - 1]);

    try {
      await kpiService.createKpi({
        ...info.dragNode,
        title: info.dragNode.name,
        _id: info.dragNode.id,
        children: [],
        parent: info.node.id,
      });
      toast.success("directory changed order");
      if (forceUpdateDataset) forceUpdateDataset();
    } catch (err) {
      toast.error("change order has error");
      console.log(err);
    }
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
    setAutoExpandParent(false);
  };

  const onSelect = (selectedKeysValue, info) => {
    setSelectedKeys(selectedKeysValue);
  };

  const onCheck = (checkedKeysValue, info) => {
    if (multiple) setCheckedKeys(checkedKeysValue);
    else {
      if (info.checked) {
        setCheckedKeys([info.node.key]);
      } else {
        setCheckedKeys([...checkedKeys.filter((x) => x !== info.node.key)]);
      }
    }
  };

  const generateList = (data, temp = []) => {
    for (let i = 0; i < data.length; i++) {
      const node = data[i];
      const { key } = node;
      temp.push({ ...node, key });

      if (node.children) {
        generateList(node.children, temp);
      }
    }

    return temp;
  };

  const loop = (data) =>
    data.map((item) => {
      const index = (item.title || "")
        .toLowerCase()
        .indexOf(filter.toLowerCase());
      const beforeStr = (item.title || "").substr(0, index);
      const afterStr = (item.title || "").substr(index + filter.length);
      const title =
        index > -1 ? (
          <div>
            {beforeStr}
            <span className="text-primary">{filter}</span>
            {afterStr}
          </div>
        ) : (
          <div>{item.title || ""}</div>
        );

      if (item.children) {
        return { ...item, title, key: item.key, children: loop(item.children) };
      }

      return {
        ...item,
        title,
        key: item.key,
      };
    });

  const getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key;
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children);
        }
      }
    }
    return parentKey;
  };

  useEffect(() => {
    const res = generateList(dataSource, []);
    setDataList(res);
    // eslint-disable-next-line
  }, [dataSource]);

  useEffect(() => {
    handleFilterData(
      filter,
      dataList,
      setExpandedKeys,
      setAutoExpandParent,
      getParentKey
    );
    // eslint-disable-next-line
  }, [dataList]);

  useEffect(() => {
    if (!handleSearch) {
      const expandedKeys = dataList
        .map((item) => {
          // if (item.title.indexOf(filter) > -1) {
          if (
            (item.title || "").toLowerCase().indexOf(filter.toLowerCase()) > -1
          ) {
            return getParentKey(item.key, dataSource);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);

      setExpandedKeys(expandedKeys);
      setAutoExpandParent(true);
    } else {
      handleSearch(filter, setExpandedKeys);
    }
    // eslint-disable-next-line
  }, [filter]);

  useEffect(() => {
    handleChange(checkedKeys);
    // eslint-disable-next-line
  }, [checkedKeys]);

  return (
    <>
      {search && (
        <div className="flex flex-col mb-2 p-2">
          <Search
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            name="tree-search"
          />
        </div>
      )}

      <Tree
        className="h-0 flex-grow overflow-auto"
        loading={loading}
        checkable={checkable}
        showLine={{ hideLeafIcon: true }}
        onExpand={onExpand}
        expandedKeys={expandedKeys}
        autoExpandParent={autoExpandParent}
        onCheck={onCheck}
        checkedKeys={checkedKeys}
        onSelect={onSelect}
        selectedKeys={selectedKeys}
        treeData={loop(dataSource)}
        draggable={customizable}
        onDrop={onDrop}
        blockNode={customizable}
        onClick={handleSelect}
        loadData={loadData}
        multiple={multiple}
        titleRender={(node) => {
          return (
            <Dropdown
              overlay={() =>
                menu({
                  node,
                  callback: () => {
                    if (forceUpdateDataset) forceUpdateDataset();
                  },
                })
              }
              trigger={customizable ? ["contextMenu"] : []}
            >
              <div>{node.title}</div>
            </Dropdown>
          );
        }}
      />
    </>
  );
}

Treeview.propTypes = {
  dataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  name: PropTypes.string.isRequired,
};

export default Treeview;

const CreateTree = ({ parent, callback = (data) => {} }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleFinish = async (values) => {
    try {
      await kpiService.createKpi({ ...values, parent });
      toast.success("directory created");
      callback();
      handleCancel();
    } catch (err) {
      toast.error("create has error");
      console.log(err);
    }
  };

  return (
    <>
      <Menu.Item key="1" onClick={showModal}>
        New Directory
      </Menu.Item>

      <Modal
        title="New Directory"
        visible={isModalVisible}
        onOk={() => form.submit()}
        onCancel={handleCancel}
      >
        <Form form={form} onFinish={handleFinish} layout="vertical">
          <Form.Item name="name" label={"Directory Name"}>
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

const RenameTree = ({ id, node, callback = (data) => {} }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleFinish = async (values) => {
    try {
      await kpiService.createKpi({
        ...node,
        ...values,
        title: node.name,
        _id: node.id,
        children: [],
      });
      toast.success("directory renamed");
      callback();
      handleCancel();
    } catch (err) {
      toast.error("renamed has error");
      console.log(err);
    }
  };

  return (
    <>
      <Menu.Item key="0" onClick={showModal}>
        Rename Directory
      </Menu.Item>

      <Modal
        title="Rename Directory"
        visible={isModalVisible}
        onOk={() => form.submit()}
        onCancel={handleCancel}
      >
        <Form
          form={form}
          onFinish={handleFinish}
          layout="vertical"
          initialValues={{ name: node.name }}
        >
          <Form.Item name="name" label={"Directory Name"}>
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

const DeleteTree = ({ node, callback = (data) => {} }) => {
  function showDeleteConfirm() {
    confirm({
      title: "Are you sure delete this Directory?",
      icon: <ExclamationCircleOutlined />,
      // content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        return new Promise((resolve, reject) => {
          kpiService
            .deleteKpi({ _id: node.id })
            .then((res) => {
              toast.success("directory deleted");
              callback();
              resolve(true);
            })
            .catch((err) => {
              toast.error("delete has error");
              console.log(err);
              reject(err);
            });
        });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  }

  return (
    <>
      <Menu.Item key="2" onClick={showDeleteConfirm}>
        Delete Directory
      </Menu.Item>
    </>
  );
};
